import React from 'react';
import { Button } from '@mui/material';

export function ArtifactReviewPatternButton({
  liveCasePath,
  livePatternPath,
  onNavigate,
}: {
  liveCasePath: string;
  livePatternPath: string;
  onNavigate: (path: string) => void;
}) {
  if (!liveCasePath || !livePatternPath) return null;
  return (
    <Button
      variant="text"
      onClick={() => onNavigate(livePatternPath)}
      sx={{ textTransform: 'none' }}
      data-testid="artifact-review-pattern"
    >
      Review pattern
    </Button>
  );
}

export function ArtifactOpenLinkedSafetyCaseButton({
  liveCasePath,
  onNavigate,
}: {
  liveCasePath: string;
  onNavigate: (path: string) => void;
}) {
  if (!liveCasePath) return null;
  return (
    <Button
      variant="contained"
      size="small"
      sx={{ mt: 1.5, textTransform: 'none', fontWeight: 700 }}
      onClick={() => onNavigate(liveCasePath)}
      data-testid="artifact-open-linked-safety-case"
    >
      Open safety case
    </Button>
  );
}
